// Phase F4 — Vehicle CRUD client.

import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type VehicleClass = "MOTORCYCLE" | "CAR" | "VAN" | "TRUCK_SMALL" | "TRUCK_LARGE";

export interface IVehicle {
  id: string;
  businessId: string;
  plateNumber: string;
  vehicleClass: VehicleClass;
  make: string | null;
  model: string | null;
  year: number | null;
  licenseExpiryDate: string | null;
  registrationDocUrl: string | null;
  lastMaintenanceDate: string | null;
  nextMaintenanceDueDate: string | null;
  maintenanceNotes: string | null;
  isActive: boolean;
  notes: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface ICreateVehicleInput {
  plateNumber: string;
  vehicleClass?: VehicleClass;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  licenseExpiryDate?: string | null;
  registrationDocUrl?: string | null;
  lastMaintenanceDate?: string | null;
  nextMaintenanceDueDate?: string | null;
  maintenanceNotes?: string | null;
  isActive?: boolean;
  notes?: string | null;
}

export const list = async (params?: {
  filter?: { search?: string | null; isActive?: boolean | null; vehicleClass?: VehicleClass | null };
  offset?: { limit: number; skip: number };
}): Promise<{ rows: IVehicle[]; count: number }> =>
  httpRequest.post("/ord/vehicle/list", (params ?? {}) as never);

export const get = async (id: string): Promise<IVehicle> =>
  httpRequest.get(`/ord/vehicle/${id}`);

export const create = async (input: ICreateVehicleInput): Promise<IVehicle> =>
  httpRequest.post("/ord/vehicle", input as never);

export const update = async (id: string, patch: Partial<ICreateVehicleInput>): Promise<IVehicle> =>
  httpRequest.put(`/ord/vehicle/${id}`, patch as never);

export const remove = async (id: string): Promise<{ removed: boolean }> =>
  httpRequest.del(`/ord/vehicle/${id}`);
